import { Flex, Spacing } from '@billy/design-system'
import { ReactElement, useCallback } from 'react'

import { Attachment } from '../../../../types/attachment'
import { UploadingAttachmentItem } from './elements/UploadingAttachmentItem'

export interface UploadingAttachmentItemsProps {
  onCancelUpload: (id: string) => void
  uploadingAttachments: Attachment[]
}

export const UploadingAttachmentItems = ({
  onCancelUpload,
  uploadingAttachments,
}: UploadingAttachmentItemsProps): ReactElement | null => {
  const handleCancelUpload = useCallback((id: string) => onCancelUpload(id), [onCancelUpload])

  if (!uploadingAttachments.length) {
    return null
  }

  return (
    <Flex flexDirection="column" gap={Spacing.S8} justifyContent="flex-start">
      {uploadingAttachments.map((attachment) => (
        <UploadingAttachmentItem attachment={attachment} key={attachment.id} onCancel={handleCancelUpload} />
      ))}
    </Flex>
  )
}
